import { AccountReturnStatistic, CumulativeDividends, DividendDistributions } from 'types/historical-performance';
import { apiRequest } from '@utils/request';

export const getCumulativeDividends = async (): Promise<CumulativeDividends> => {
	const response = await apiRequest.get(`/aps/historical-performance/cumulative-platform-dividends`);
	return response.data;
};

export const getAccountReturnsByTimeOnPlatform = async (): Promise<Array<AccountReturnStatistic>> => {
	const response = await apiRequest.get(`/aps/historical-performance/account-returns-statistics`);
	return response.data;
};

export const getDividendsDistributions = async (): Promise<DividendDistributions> => {
	const response = await apiRequest.get(`/aps/historical-performance/dividend-yields`);
	return response.data;
};
